<div class="chat-message" [class.user-message]="message.role === 'User'" [class.assistant-message]="message.role === 'Assistant'">
  <div class="message-header">
    <mat-icon class="message-icon">{{ message.role === 'User' ? 'person' : 'smart_toy' }}</mat-icon>
    <span class="message-role">{{ message.role === 'User' ? 'You' : 'AI Assistant' }}</span>
    <span class="message-time">{{ message.timestamp | utcDate:'short' }}</span>
  </div>
  
  <div class="message-content">
    <!-- Render parsed content with tables -->
    @for (block of parsedContent; track block) {

      <!-- Text content -->
      @if (block.type === 'text') {
<p [innerHTML]="block.content | linkify"></p>
}
      
      <!-- Table content -->
      @if (block.type === 'table') {
<div class="markdown-table-container">
        <table class="markdown-table">
          <thead>
            <tr>
              @for (header of block.content.headers; track header) {
<th>{{ header }}</th>
}
            </tr>
          </thead>
          <tbody>
            @for (row of block.content.rows; track row) {
<tr>
              @for (cell of row; track cell) {
<td>{{ cell }}</td>
}
            </tr>
}
          </tbody>
        </table>
      </div>
}
    
}
    @if (message.isStreaming) {
<span class="streaming-cursor" aria-hidden="true"></span>
}
  </div>

  @if (message.jobProgress) {
<div class="inline-job-status" [class.inline-job-status--complete]="!message.jobProgress.isActive">
    <span class="inline-job-status__dot"></span>
    <span>
      {{ message.jobProgress.jobType === 'Readiness' ? 'CMDB readiness refresh' : 'Assessment' }}
      — {{ message.jobProgress.status }}
    </span>
    @if (!message.jobProgress.isActive) {
    <button type="button" class="inline-job-status__link" (click)="navigateTo(getJobDetailsRoute())">
      View details
    </button>
    }
  </div>
}

  <!-- Quick-reply chips: shown for the last assistant message when Nora lists options -->
  @if (isLastMessage && !message.isStreaming && quickReplySuggestions.length > 0) {
<div class="quick-replies">
    @for (suggestion of quickReplySuggestions; track suggestion) {
<button mat-stroked-button class="quick-reply-chip" (click)="onQuickReply(suggestion)">
        {{ suggestion }}
      </button>
}
  </div>
}

  <!-- Action links: navigation buttons injected by the chat container (e.g. "View Results") -->
  @if (message.actionLinks && message.actionLinks.length > 0) {
<div class="action-links">
    @for (link of message.actionLinks; track link.route) {
<button mat-flat-button color="primary" class="action-link-btn" (click)="navigateTo(link.route)">
        <mat-icon>open_in_new</mat-icon>
        {{ link.label }}
      </button>
}
  </div>
}

  @if (message.sources && message.sources.length > 0) {
<div class="message-sources">
    <div class="sources-label">
      <mat-icon>link</mat-icon>
      <span>Sources:</span>
    </div>
    <mat-chip-listbox class="sources-chips">
      <!-- Show first MAX_VISIBLE_SOURCES or all if expanded -->
      @for (source of visibleSources; track source) {
<mat-chip-option 
                       (click)="openSource(source.sourceUrl)"
                       class="source-chip">
        <mat-icon matChipAvatar>{{ source.sourceSystem === 'CMDB' ? 'storage' : source.sourceSystem === 'View Details' ? 'open_in_new' : 'assessment' }}</mat-icon>
        {{ source.entityName || source.sourceSystem }}
      </mat-chip-option>
}
    </mat-chip-listbox>
    <!-- Show "More sources" button if there are more than MAX_VISIBLE_SOURCES -->
    @if (message.sources.length > MAX_VISIBLE_SOURCES) {
<button 
        (click)="toggleSources()"
        class="sources-toggle-btn"
        [attr.aria-expanded]="expandedSources">
        @if (!expandedSources) {
          <mat-icon>expand_more</mat-icon>
          <span>{{ message.sources.length - MAX_VISIBLE_SOURCES }} more source{{ message.sources.length - MAX_VISIBLE_SOURCES !== 1 ? 's' : '' }}</span>
        } @else {
          <mat-icon>expand_less</mat-icon>
          <span>Show less</span>
        }
      </button>
}
  </div>
}
</div>
